module.exports = __webpack_public_path__ + "media/svg-new/counting-3b9480fa.svg";